/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitQuickBaselineRequest
 */
export interface SubmitQuickBaselineRequest {
    /**
     * 
     * @type {string}
     * @memberof SubmitQuickBaselineRequest
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitQuickBaselineRequest
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitQuickBaselineRequest
     */
    scoringVersion?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SubmitQuickBaselineRequest
     */
    answers?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof SubmitQuickBaselineRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the SubmitQuickBaselineRequest interface.
 */
export function instanceOfSubmitQuickBaselineRequest(value: object): value is SubmitQuickBaselineRequest {
    return true;
}

export function SubmitQuickBaselineRequestFromJSON(json: any): SubmitQuickBaselineRequest {
    return SubmitQuickBaselineRequestFromJSONTyped(json, false);
}

export function SubmitQuickBaselineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitQuickBaselineRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'scoringVersion': json['scoringVersion'] == null ? undefined : json['scoringVersion'],
        'answers': json['answers'] == null ? undefined : json['answers'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function SubmitQuickBaselineRequestToJSON(json: any): SubmitQuickBaselineRequest {
    return SubmitQuickBaselineRequestToJSONTyped(json, false);
}

export function SubmitQuickBaselineRequestToJSONTyped(value?: SubmitQuickBaselineRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'profileId': value['profileId'],
        'frameworkSlug': value['frameworkSlug'],
        'scoringVersion': value['scoringVersion'],
        'answers': value['answers'],
        'effectTenantId': value['effectTenantId'],
    };
}

